import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class WafCaptchaService {
  private get waf() { return (window as any).AwsWafCaptcha; }
  private get integ() { return (window as any).AwsWafIntegration; }
  sdkLoaded(): boolean {
    return !!this.waf && !!this.integ;
  }
  /** Render the CAPTCHA and resolve with a valid token when solved. */
  render(container: Element): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!this.sdkLoaded()) return reject(new Error('AWS WAF SDK not loaded'));
      this.waf!.renderCaptcha(container, {
        apiKey: environment.wafCaptchaApiKey,
        dynamicWidth: true,
        skipTitle: false,
        onSuccess: (token: string) => resolve(token),
        onError: (err: unknown) => reject(err),
      });
    });
  }
  /** True if a usable token is currently cached. */
  hasToken(): boolean {
    return !!this.integ?.hasToken?.();
  }
  /** Get (or refresh) a token explicitly. */
  async getToken(): Promise<string> {
    if (!this.sdkLoaded()) throw new Error('AWS WAF SDK not loaded');
    return await this.integ!.getToken();
  }
  /**
   * Direct wrapper around AwsWafIntegration.fetch.
   * Use this if you prefer `fetch` over Angular HttpClient for protected calls.
   */
  async wafFetch(input: RequestInfo, init?: RequestInit): Promise<Response> {
    if (!this.sdkLoaded()) return fetch(input, init);
    return this.integ!.fetch(input, init);
  }
}
